import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Api from "src/services/api";
import { PapiroConsole } from "src/utils/papiroConsole";
import { useHistory } from "react-router-dom";

const BlockCard = (props) => {

    const { block, openKnowledgeBaseDialog } = props

    const [src, setSrc] = useState('')

    let history = useHistory()

    const getFile = async (image) => {
        let xhttpImage = new XMLHttpRequest()
        xhttpImage.open("GET", `${image.anonymoustoken}`, false)
        xhttpImage.setRequestHeader('Access-Control-Allow-Origin', '*')
        try {
            xhttpImage.send()
            let ImageData = JSON.parse(xhttpImage.responseText)
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                setSrc(ImageData.data)
            }
        }
        catch (e) {
            PapiroConsole.log("e")
            PapiroConsole.log(e)
        }
    }

    const handleClick = async () => {
        switch (block.clientportalblocktype) {
            case 1:
                openKnowledgeBaseDialog(block.knowledgebaseid)
                break

            case 2:
                let language = window.location.pathname.split('/')[1]
                if (language != "pt" && language != "es" && language != "en")
                    language = "pt"

                history.push(`/${language}/article-external/${block.articleid}`)
                break

            case 3:
                window.open(`${block.link}`, '_blank')
                break
        }
    }

    useEffect(async () => {
        if (block.image) {
            getFile(block.image)
        }
    }, [block])

    return (
        <Grid item key={block.id}>
            <Card onClick={handleClick} style={{ cursor: "pointer" }}>
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                    <Box
                        sx={{
                            width: "15vw",
                            height: "5vw",
                            bgcolor: 'primary.lighter',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 2
                        }}
                    >
                        {block.image && <img src={src} alt={block.title} width="50" height="50" />}
                    </Box>

                    <Typography variant="h6" component="h3" gutterBottom textAlign="center">
                        {block.title}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    )
}

export default BlockCard;